module.exports = __webpack_public_path__ + "img/01_icon_1.71cdfd5d.svg";